export default {
  SET_MY_CALENDAR_EVENTS: 'SET_MY_CALENDAR_EVENTS',
  SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
  CREATE_EVENT: 'CREATE_EVENT',
  UPDATE_EVENT: 'UPDATE_EVENT',
  DELETE_EVENT: 'DELETE_EVENT'
};
